import { render, staticRenderFns } from "./ServiceTaskDefaultTable.vue?vue&type=template&id=6de94503&"
import script from "./ServiceTaskDefaultTable.vue?vue&type=script&lang=ts&"
export * from "./ServiceTaskDefaultTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports